  import {Injectable} from '@angular/core';

import {HttpClient, HttpHeaders, HttpParams, HttpRequest} from '@angular/common/http';
import {Globals} from "../../globals";
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class ListingBrowseService {

  constructor(private http: HttpClient, public globals: Globals,) {
  }

  getItems(url: string, param: any) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'X-Data': btoa(JSON.stringify(param))
    });
    return this.http.get(url, {
      headers: headers,
      responseType: 'json',
      reportProgress: true
    });
  }
  getProfileByAccountName(url: string, profile: string) {
    let params = new HttpParams();
    params = params.append('username', profile);
    return this.http.get(url, {params:params});
  }

  getCounties(url: string, param: string) {
    return this.http.get(url + param);
  }

  getItemsCategories(url: string, param: any): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'X-Custom-Header': JSON.stringify(param)
    });
    return this.http.get(url, {
      headers: headers,
      responseType: 'json',
      reportProgress: true
    });
  }

  /** GET with filter payload in X-Data header (listings search, sidebar, etc.). */
  getWithDataHeader(url: string, params: any): Observable<any> {
    const encodedFilter = btoa(JSON.stringify(params));
    return this.http.get<any>(`${url}`, {
      headers: { 'X-Data': encodedFilter }
    });
  }


  getPageCount(url: string, param: any) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'X-Data': btoa(JSON.stringify(param))
    });
    return this.http.get(url, {
      headers: headers,
      responseType: 'json',
      reportProgress: true
    });

  }

  getBasicFilter(url: string, param: any) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'X-Data': btoa(JSON.stringify(param))
    });
    return this.http.get(url, {
      headers: headers,
      responseType: 'json',
      reportProgress: true
    });
    /*let params = new HttpParams();
    params = params.append('listingFilter', JSON.stringify(param));
    return this.http.get(url,  {params:params});*/
  }

  getSearchItem(url: string, itemName : string) {
    let params = new HttpParams();
    params = params.append('itemName', itemName);
    return this.http.get(url + '/item/category', {params:params});
  }

  getSearchCategoriesProfile(url: string, category : string, subcategory : string, profile : string, listingFilter : any) {
    let params = new HttpParams();
    params = params.append('listingFilter', JSON.stringify(listingFilter));
    params = params.append('category', category);
    params = params.append('subcategory', subcategory);
    params = params.append('profile', profile);
    return this.http.get(url , {params:params});
  }

  getItem(url: string, id : string) {
    let params = new HttpParams();
    console.log('tester');
    params = params.append('id', id);
    return this.http.get(url + '/item', {params:params});
  }

  saveFilter(url: string, categoriesArray: any) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    let params = new HttpParams();
    params = params.append('paramFilter', btoa(JSON.stringify(categoriesArray)));
    return this.http.post(url, null, {params: params, headers: headers});
  }

  deleteFilter(url: string, categoriesArray: any) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    let params = new HttpParams();
    params = params.append('paramFilter', btoa(JSON.stringify(categoriesArray)));
    return this.http.post(url, null, {params: params, headers: headers});
  }







}

/** @deprecated Use ListingBrowseService */
export {ListingBrowseService as AllService};
